module.exports = __webpack_public_path__ + "static/img/img_cabinet.7a4cf270.png";